// Shared palette + helpers for the Digital E-Sign Ledger screens.
// Colours ported from the FruitX Ledger eSign prototype.

export const FX = {
  orange: "#FF6A00", // e-Sign accent
  teal: "#1B6E64",
  tealDeep: "#0E3D38",
  green: "#018868",
  greenBright: "#1FA971",
  mint: "#E3F3EE",
  mintPale: "#EAF6F2",
  line: "#E1E7E5",
  bg: "#F4F6F6",
  ink: "#16201E",
  muted: "#5B6B68",
  muted2: "#7C8C89",
  muted3: "#94A3A0",
  red: "#DB2B29",
};

export const ACCENT = FX.orange;

export const inr = (value) => {
  const n = Number(value || 0);
  return (
    `₹${ 
    n.toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`
  );
};

export const todayStr = () => {
  const d = new Date();
  const m = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
  ];
  return `${String(d.getDate()).padStart(2, "0")} ${m[d.getMonth()]} ${d.getFullYear()}`;
};

// mask a phone like +91 98765 43210 -> +91 98765 ••210
export const maskPhone = (phone) => {
  if (!phone) return "";
  const digits = String(phone).replace(/\D/g, "");
  if (digits.length < 4) return phone;
  const last3 = digits.slice(-3);
  const head = digits.slice(0, Math.max(0, digits.length - 6));
  return `+91 ${head} ••${last3}`.trim();
};
